export default function () {

    const header = document.querySelector('.js-header');

    window.addEventListener('scroll', function() {

        let scroll = window.scrollY;

        if (scroll > 0) {
            header.classList.add('stick');
        } else {
            header.classList.remove('stick');
        }

    });

}
